import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
import step01 from '@/views/step/step01'
import step02 from '@/views/step/step02'
import step03 from '@/views/step/step03'
import success from '@/views/step/success'
import password from '@/views/password/password'
import industry from '@/views/industry/industry'
import problem from '@/views/problem/problem'
import problemDetail from '@/views/problem/problemDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/step01',
      name: 'step01',
      component: step01,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/step02',
      name: 'step02',
      component: step02,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/step03',
      name: 'step03',
      component: step03,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/success',
      name: 'success',
      component: success,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/industry',
      name: 'industry',
      component: industry,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/problem',
      name: 'problem',
      component: problem,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/problemDetail',
      name: 'problemDetail',
      component: problemDetail,
      meta: {
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js